export const ASSET_CONSTANTS = {
  LOGO: '/images/logo.png',
  LOGO_MIN: '/icons/logo-min.svg',
  LOGIN_BACKGROUND: 'images/citizen-auth.png',
  I_location_buffer: 'icons/location-01.svg',
  I_category_buffer: 'icons/security-warning.svg',
  I_building_buffer: 'icons/building.svg',
  I_arrow_down: 'icons/arrow-down.svg',
  I_arrow_down_white: 'icons/arrow-down-white.svg',
  I_arrow_left: 'icons/arrow-left.svg',
  I_arrow_left_side: 'icons/arrow-left-side.svg',
  I_arrow_left_black: 'icons/arrow-left-black.svg',
  I_arrow_right: 'icons/arrow-right.svg',
  I_arrow_point_right: 'icons/arrow-point-right.svg',
  I_attachment: 'icons/attachment.svg',
  I_bank: 'icons/bank.svg',
  I_bell: 'icons/bell.svg',
  I_unopen_bell: 'icons/unopen-bell.svg',
  I_bell_filled: 'icons/bell-filled.svg',
  I_bin: 'icons/bin.svg',
  I_bubble_chat: 'icons/bubble-chat-question.svg',
  I_calendar: 'icons/calendar.svg',
  I_calendar_add: 'icons/calendar-add.svg',
  I_check_circle: 'icons/check-circle.svg',
  I_check: 'icons/check.svg',
  I_chevron_down: 'icons/chevron-down.svg',
  I_chevron_left: 'icons/chevron-left.svg',
  I_chevron_right: 'icons/chevron-right.svg',
  I_clock: 'icons/clock.svg',
  I_clock_white: 'icons/clock-white.svg',
  I_customer_service: 'icons/customer-service.svg',
  I_close_circle: 'icons/close-circle.svg',
  I_comment: 'icons/comment.svg',
  I_cancel: 'icons/cancel.svg',
  I_danger: 'icons/danger.svg',
  I_delete: 'icons/delete.svg',
  I_download: 'icons/download.svg',
  I_edit: 'icons/edit.svg',
  I_edit_box: 'icons/edit_box.svg',
  I_edit_box_black: 'icons/edit_box_black.svg',
  I_empty_list: 'icons/empty-list.svg',
  I_eye_closed: 'icons/eye-closed.svg',
  I_eye_open: 'icons/eye-open.svg',
  I_eye_primary: 'icons/eye-primary.svg',
  I_file_upload: 'icons/file-attachment.svg',
  I_filter_vertical: 'icons/filter-vertical.svg',
  I_headset: 'icons/headset.svg',
  I_image_upload: 'icons/image-upload.svg',
  I_info_circle: 'icons/info-circle.svg',
  I_info: 'icons/info.svg',
  I_globe: 'icons/globe.svg',
  I_loading: 'icons/loading.svg',
  I_logout: 'icons/logout.svg',
  I_menu: 'icons/menu.svg',
  I_minus: 'icons/minus.svg',
  I_more_vertical: 'icons/more-vertical.svg',
  I_notification: 'icons/notification.svg',
  I_paper_clip: 'icons/paper-clip.svg',
  I_pdf: 'icons/pdf.svg',
  I_pencil: 'icons/pencil.svg',
  I_plus_circle: 'icons/plus-circle.svg',
  I_plus: 'icons/plus.svg',
  I_profile: 'icons/profile.svg',
  I_question: 'icons/question.svg',
  I_user: 'icons/user.svg',
  I_search: 'icons/search.svg',
  I_search_gray: 'icons/search-gray.svg',
  I_settings: 'icons/settings.svg',
  I_sliders: 'icons/sliders.svg',
  I_share: 'icons/share.svg',
  I_sort: 'icons/sort.svg',
  I_stars: 'icons/stars.svg',
  I_star: 'icons/star.svg',
  I_success: 'icons/success.svg',
  I_warning: 'icons/warning.svg',
  I_whatsapp_share: 'icons/whatsapp.svg',
  I_send: 'icons/send.svg',
  I_info_black: 'icons/info-black.svg',
};
